/**
 * 用于带默认值执行 config 的回调方法
 * @param config - config 的回调
 * @param defaultValue - 默认值
 * @param args - 参数
 * @internal
 * @privateRemarks
 * config类型改成 T | ((...params: any[]) =\> T)，ts认为不一定是callable
 * https://github.com/microsoft/TypeScript/issues/37663
 * 我们需要这个函数能成功的类型推断T
 * 但是config设成any可能会产生错误，这里的类型推断只能由config产生
 * 例如  evaluate\<TooltipConfig| string | undefined\>(tooltipConfig, undefined);
 * 为什么写<T>是因为defaultValue是undefined
 * 所以当T没有写，就会错误的由defaultValue推断T
 * 还有一种可能是T写了就变成了强制类型转换，也会出错
 * 即使改成issue里面说的方法，也没有办法限制defaultValue类型
 */
function evaluate(config, defaultValue, ...args) {
    var _a;
    if (typeof config === 'function') {
        return (_a = config(...args)) !== null && _a !== void 0 ? _a : defaultValue;
    }
    return config !== null && config !== void 0 ? config : defaultValue;
}

export { evaluate };
//# sourceMappingURL=evaluate.js.map
